export const styles = {
  container:
    'tw-flex tw-items-center tw-justify-between tw-p-3 tw-border-solid tw-border tw-border-neutral-200 tw-rounded-lg tw-transition-colors',
  info: 'tw-flex tw-items-center tw-gap-2',
  icon: 'tw-text-primary-600',
  name: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  deleteButton: 'tw-text-danger-600',
};
